import { Api } from "./api"
import { GetFileContent } from "./api.types"
import { getGeneralApiProblem } from "./api-problem"

export class FileApi {
  private api: Api

  constructor(api: Api) {
    this.api = api
  }
  
  async get(file: File) : Promise<GetFileContent> {
    try {
      const response = await this.api.getFileContent(file)

      if (!response.ok) {
        const problem = getGeneralApiProblem(response)
        if (problem) return problem
      }

      const payload = response.data

      return { kind: 'ok', payload }
    } catch (e) {
      return { kind: "bad-data" }
    }
  }
}
